import { qantProductAdmin } from '../condition.js';
import type { ProductMenuDef } from '../type.js';

/**
 * Knowledge Hub (管理画面) の現状ナビ忠実版メニュー。
 * 出典: apps/knowledge/packages/front/src/ui/page/Layout/makeMenuGroups.tsx
 */
export const QANT_KNOWLEDGE_MENU = {
  product: {
    name: 'knowledge',
    icon: 'qantKnowledge',
    label: { ja: 'ナレッジハブ', en: 'Knowledge Hub' },
    description: { ja: 'ナレッジデータ基盤', en: 'Knowledge Hub' },
  },
  menuGroups: {
    BASIC: {
      name: 'basic',
      label: { ja: '基本', en: 'Basic' },

      menus: {
        LIBRARY: {
          name: 'library',
          icon: 'knowledgeLibrary',
          label: { ja: 'ライブラリ', en: 'Library' },
          path: { host: 'qant', path: '/knowledge/' },
        },
        COMMENT: {
          name: 'comment',
          icon: 'knowledgeComment',
          label: { ja: 'コメント', en: 'Comments' },
          path: { host: 'qant', path: '/knowledge/comment' },
          // isCommentEnabled (knowledge の system setting) は auth からは取れないため、
          // knowledge front の useTransformProducts で絞る。
        },
        DOC_IMPROVEMENT: {
          name: 'docImprovement',
          icon: 'docImprovement',
          label: { ja: 'ドキュメント改善', en: 'Document Improvement' },
          path: { host: 'qant', path: '/knowledge/doc-improvement' },
          // canViewDocImprovement (= FaqImprovement 権限) は has利用権限 に緩和済みのため、
          // product 表示 (= 利用権限) と同一で足り、専用 condition は不要。
          // isFaqImprovementEnabled (knowledge の system setting) は auth からは取れないため、
          // knowledge front の useTransformProducts で絞る。
        },
        DOCUMENT_COVERAGE: {
          name: 'documentCoverage',
          icon: 'documentCoverage',
          label: { ja: 'カバー率分析', en: 'Coverage Analysis' },
          path: { host: 'qant', path: '/knowledge/document-coverage' },
          // isDocumentCoverageEnabled (knowledge の system setting) は auth からは取れないため、
          // knowledge front の useTransformProducts で絞る。
        },
      },
    },
    MANAGE: {
      name: 'manage',
      label: { ja: '管理', en: 'Manage' },
      menus: {
        SETTINGS: {
          name: 'settings',
          icon: 'settings',
          label: { ja: '設定', en: 'Settings' },
          path: { host: 'qant', path: '/knowledge/settings' },
          // v1: canAccessSettings (= has管理権限)
          condition: qantProductAdmin('knowledge'),
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
